import Vue from 'vue';
import ConfirmationMixin from './confirmation.mixin';
import ActionNotificationMixin from './action-notification.mixin';
import EventBusMixin from './event-bus.mixin';
import UnsavedChangesHookMixin from './unsaved-changes-hook.mixin';

Vue.mixin(ConfirmationMixin)
Vue.mixin(ActionNotificationMixin)
Vue.mixin(EventBusMixin)
Vue.mixin(UnsavedChangesHookMixin)
